export default __webpack_public_path__ + "static/media/pencil.67dc82cc.svg";